<template>
    <div class="panel-content">
        <h2>Wat ons uniek maakt</h2>
        <img class="header" src="/static/img/overlay-assets/header4-4.jpg" />
        <p>Onze therapiefaciliteit waar 8 patiënten opgevangen kunnen worden is uniek. Daarnaast in de kliniek is de beschikbaarheid van een PET/MRI scanner echt bijzonder, er zijn er maar 3 in Nederland en een10-tal meer in de rest van Europa. De twee PET/CT en SPECT/CT camera’s zijn eigenlijk de normale gereedschap voor een nucleaire geneeskunde afdeling. In de prekliniek hebben we de beschikking over een zondvloed aan apparatuur: SPECT/MRI, high-energy SPECT/PET/CT/ optical scanner, en een faciliteit waarin we met hoge doses radioactiviteit bijvoorbeeld therapie experimenten mogen uitvoeren in proefdieren.</p>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

    };
</script>
